import {
  MEDIA_ATTACHMENT_FIELD_DEFAULT_PROPS,
  MediaAttachmentFieldProps,
} from '../core-field/media-attachment-field-props'

export type PhotoCaptureMode = 'photo' | 'ocr'
export type SampleImageDisplay = 'preCapture' | 'inline' | 'link'

export interface SampleImage {
  uri: string
  caption?: string
}

/**
 * Photo-capture field with an optional OCR mode. Replaces the legacy
 * `FormPhotoCaptureField` and `FormOcrCameraField` pair.
 */
export const UI2_PHOTO_CAPTURE_FIELD_DEFAULT_PROPS: Partial<UI2PhotoCaptureFieldProps> = {
  ...MEDIA_ATTACHMENT_FIELD_DEFAULT_PROPS,
  mode: 'photo',
  sampleImageDisplay: 'preCapture',
}

export interface UI2PhotoCaptureFieldProps extends MediaAttachmentFieldProps {
  /** Selects between photo-array capture and OCR text capture. Default: 'photo'. */
  mode?: PhotoCaptureMode

  // ─── Photo mode ────────────────────────────────────────────────────────────
  /** Default help text on required-slot placeholder tiles. */
  captureHelpText?: string
  /** Per-slot help text; index N maps to slot N; falls back to `captureHelpText`. */
  multiCaptureHelpText?: string[]
  sampleImages?: SampleImage[]
  /** How sample images render. Default: 'preCapture'. */
  sampleImageDisplay?: SampleImageDisplay

  // ─── Shared Capture Options ─────────────────────────────────────────────────
  /** Auto-preprocess captured frames to grayscale. */
  enableAutoGrayscale?: boolean
  /**
   * Enable page-detection cropping. On mobile app, this will overlay a bounding box on
   * detected pages before the user captures the image. On mobile web, this will
   * automatically crop the detected page after capture. */
  enablePageDetection?: boolean
  /** Open the capture modal immediately on mount. */
  openCaptureOnMount?: boolean

  // ─── OCR mode ───────────────────────────────────────────────────────────────
  /**
   * Path on the parent entity where the captured OCR text is stored.
   * On DW and MW, when `mode === 'ocr'`, this field renders a plain text input
   * bound to this path so the user can enter the value manually.
   */
  ocrValuePath?: string
}
